// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"DailySummaryReceivedAndReleased_tableWrapper__2Atw6"};